export default __webpack_public_path__ + "static/illustartion1-9c39b80172aba5665852bc6243ffd600.svg";